module.exports = __webpack_public_path__ + "static/media/budget.c49ba3cc.svg";